"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chosen = exports.ChosenField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var fieldMaker_1 = require("../fieldMaker");
var fieldProvisioner_1 = require("../fieldProvisioner");
var input_1 = require("../input");
require("./chosen.css");
var ChosenField = /** @class */ (function (_super) {
    __extends(ChosenField, _super);
    function ChosenField(props) {
        var _this = _super.call(this, props) || this;
        _this.ulListRef = React.createRef();
        _this.onChange = function (data) { return function () {
            return _this.setState({ open: false, filtering: false }, function () { return _this.props.onChange && _this.props.onChange(data.value, data); });
        }; };
        _this.onFilter = function (filter) {
            _this.setState({ filter: filter, filtering: true }, function () {
                if (_this.props.value && _this.props.onChange) {
                    _this.props.onChange(undefined, undefined);
                }
                _this.props.onFilter(filter);
            });
        };
        /*
         * To Raffine
         */
        _this.scrollElement = function (index, direction) {
            return (0, function_1.pipe)(O.fromNullable(_this.ulListRef.current), O.map(function (ul) {
                var y = index * ChosenField.chosenElemHeight;
                var delta = ChosenField.chosenListHeight - ChosenField.chosenElemHeight;
                switch (direction) {
                    case 'down':
                        return y > delta ? ul.scrollTo(0, y - delta) : null;
                    case 'up':
                        return y < delta ? ul.scrollTo(0, y) : null;
                }
            }));
        };
        _this.getValues = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.options), O.map(function (os) { return os.map(function (o) { return o.value; }); }), O.getOrElse(function () { return []; }));
        };
        _this.manageKeyDown = function (keyCode) {
            switch (keyCode) {
                case ChosenField.keyCodeAllowed.ARROW_UP:
                    return _this.setState(function (prevState) { return ({
                        optionFocused: (0, function_1.pipe)(prevState.optionFocused, O.chain(function (f) {
                            var index = _this.getValues().indexOf(f);
                            switch (index) {
                                case -1:
                                    return O.none;
                                case 0:
                                    return O.some(f);
                                default:
                                    return O.some(_this.getValues()[index - 1]);
                            }
                        })),
                    }); }, function () {
                        return _this.scrollElement((0, function_1.pipe)(_this.state.optionFocused, O.map(function (o) { return _this.getValues().indexOf(o); }), O.getOrElse(function () { return 0; })), 'up');
                    });
                case ChosenField.keyCodeAllowed.ARROW_DOWN:
                    return _this.setState(function (prevState) { return ({
                        optionFocused: (0, function_1.pipe)(prevState.optionFocused, O.chain(function (f) {
                            var index = _this.getValues().indexOf(f);
                            switch (index) {
                                case -1:
                                    return O.none;
                                case _this.getValues().length - 1:
                                    return O.some(f);
                                default:
                                    return O.some(_this.getValues()[index + 1]);
                            }
                        }), O.alt(function () { return O.some(_this.getValues()[0]); })),
                    }); }, function () {
                        return _this.scrollElement((0, function_1.pipe)(_this.state.optionFocused, O.map(function (o) { return _this.getValues().indexOf(o); }), O.getOrElse(function () { return 0; })), 'down');
                    });
                case ChosenField.keyCodeAllowed.ENTER:
                    return (0, function_1.pipe)(_this.state.optionFocused, O.map(function (optionF) {
                        return (0, function_1.pipe)(O.fromNullable(_this.props.options), O.chainNullableK(function (opts) { return opts.filter(function (o) { return o.value === optionF; })[0]; }), O.map(_this.onChange), O.map(function (f) { return f(); }));
                    }));
            }
        };
        _this.state = {
            open: false,
            filter: _this.props.data ? _this.props.data.label : undefined,
            filtering: false,
            optionFocused: O.none,
        };
        return _this;
    }
    ChosenField.prototype.findFilter = function () {
        if (this.state.filtering) {
            return this.state.filter;
        }
        return this.props.data ? this.props.data.label : undefined;
    };
    ChosenField.prototype.componentDidUpdate = function (prevProp) {
        if (JSON.stringify(prevProp.data) !== JSON.stringify(this.props.data) ||
            JSON.stringify(this.props.options) !== JSON.stringify(prevProp.options)) {
            this.setState({ filter: this.findFilter() });
        }
    };
    ChosenField.prototype.renderList = function () {
        var _this = this;
        var options = this.props.options;
        if ((this.state.filter && this.state.filter.length < 2) || !options) {
            return null;
        }
        if (options.length === 0) {
            return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: "chosen-list" }, { children: (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("em", { children: "Nessun risultato" }) }) })));
        }
        return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: "chosen-list", ref: this.ulListRef }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)("li", __assign({ className: (0, clsx_1.default)({
                    focused: (0, function_1.pipe)(_this.state.optionFocused, O.filter(function (f) { return f === option.value; }), O.isSome),
                }), onMouseDown: _this.onChange(option) }, { children: option.label }), option.value)); }) })));
    };
    ChosenField.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("span", __assign({ className: (0, clsx_1.default)('chosen', { open: this.state.open }, this.props.className), onFocus: function () { return _this.setState({ open: true }); }, onBlur: function () { return _this.setState({ open: false }); }, onKeyDown: function (e) {
                var keyCode = e.keyCode;
                if (!_this.state.open) {
                    _this.setState({ open: true });
                }
                if (!Object.values(ChosenField.keyCodeAllowed).includes(keyCode)) {
                    return;
                }
                e.preventDefault();
                _this.manageKeyDown(keyCode);
            } }, { children: [(0, jsx_runtime_1.jsx)(input_1.Input, { name: this.props.name, type: "text", value: this.state.filter, onChange: this.onFilter, debounceTime: this.props.filterDebounceTime || 200, disabled: this.props.disabled, autoComplete: "off" }), this.renderList()] })));
    };
    ChosenField.keyCodeAllowed = {
        ARROW_UP: 38,
        ARROW_DOWN: 40,
        ENTER: 13,
    };
    ChosenField.chosenListHeight = 200;
    ChosenField.chosenElemHeight = 30.4;
    return ChosenField;
}(React.PureComponent));
exports.ChosenField = ChosenField;
exports.Chosen = (0, fieldProvisioner_1.makeFieldProvisioner)((0, fieldMaker_1.makeField)(ChosenField));
//# sourceMappingURL=Chosen.js.map